import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AvatarComponent } from '../../../shared/components/avatar/avatar.component';
import { Location, formatAddress, isActive } from '../location.model';

@Component({
  selector: 'app-location-item',
  imports: [RouterLink, AvatarComponent],
  templateUrl: './location-item.component.html',
  styleUrl: './location-item.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocationItemComponent {
  readonly location = input.required<Location>();
  protected readonly formatAddress = formatAddress;
  protected readonly isActive = isActive;
}
